import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Service Cards in Services Component - staggered fade in with scale and rotation
 */
export const animateServiceCards = (ref, slides) => {
  if (ref.current && slides && slides.length > 0) {
    // Set initial state immediately to prevent flash
    const cards = ref.current.querySelectorAll('[class*="serviceCard"], .swiper-slide [class*="serviceCard"]');
    if (cards.length > 0) {
      gsap.set(cards, { opacity: 0, scale: 0.8, rotation: -10 });
    } else {
      // Fallback: try to find cards by their container structure
      const swiperSlides = ref.current.querySelectorAll('.swiper-slide');
      if (swiperSlides.length > 0) {
        gsap.set(swiperSlides, { opacity: 0, scale: 0.8, rotation: -10 });
      }
    }
    
    const timer = setTimeout(() => {
      if (cards.length > 0) {
        gsap.to(cards, {
          opacity: 1,
          scale: 1,
          rotation: 0,
          duration: 0.9,
          stagger: 0.15,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        ScrollTrigger.refresh();
      } else {
        // Fallback: try to find cards by their container structure
        const swiperSlides = ref.current.querySelectorAll('.swiper-slide');
        if (swiperSlides.length > 0) {
          gsap.to(swiperSlides, {
            opacity: 1,
            scale: 1,
            rotation: 0,
            duration: 0.9,
            stagger: 0.15,
            ease: "back.out(1.2)",
            scrollTrigger: {
              trigger: ref.current,
              start: "top 80%",
              toggleActions: "play none none none",
            },
          });
          ScrollTrigger.refresh();
        }
      }
    }, 300);
    
    return () => clearTimeout(timer);
  }
};

